"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/cms_service.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSGoodsService = void 0;
const cms_service_pb_1 = require("./cms_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.goods.v1.CMSGoodsService
 */
exports.CMSGoodsService = {
    typeName: "spwn.goods.v1.CMSGoodsService",
    methods: {
        /**
         * グッズの単体取得
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.GetGoods
         */
        getGoods: {
            name: "GetGoods",
            I: cms_service_pb_1.CMSGoodsServiceGetGoodsRequest,
            O: cms_service_pb_1.CMSGoodsServiceGetGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * グッズの一覧取得 // TODO: deprecated?
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.GetAllGoods
         */
        getAllGoods: {
            name: "GetAllGoods",
            I: cms_service_pb_1.CMSGoodsServiceGetAllGoodsRequest,
            O: cms_service_pb_1.CMSGoodsServiceGetAllGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * グッズの一覧取得(リスト表示・ページネーション)
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.GetGoodsList
         */
        getGoodsList: {
            name: "GetGoodsList",
            I: cms_service_pb_1.CMSGoodsServiceGetGoodsListRequest,
            O: cms_service_pb_1.CMSGoodsServiceGetGoodsListResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * グッズの一括更新
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.UpdateGoodsAll
         */
        updateGoodsAll: {
            name: "UpdateGoodsAll",
            I: cms_service_pb_1.CMSGoodsServiceUpdateGoodsAllRequest,
            O: cms_service_pb_1.CMSGoodsServiceUpdateGoodsAllResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * デジタルグッズの作成
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.CreateDigitalGoods
         */
        createDigitalGoods: {
            name: "CreateDigitalGoods",
            I: cms_service_pb_1.CMSGoodsServiceCreateDigitalGoodsRequest,
            O: cms_service_pb_1.CMSGoodsServiceCreateDigitalGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * デジタルグッズの更新
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.UpdateDigitalGoods
         */
        updateDigitalGoods: {
            name: "UpdateDigitalGoods",
            I: cms_service_pb_1.CMSGoodsServiceUpdateDigitalGoodsRequest,
            O: cms_service_pb_1.CMSGoodsServiceUpdateDigitalGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * デジタルグッズの削除
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.DeleteDigitalGoods
         */
        deleteDigitalGoods: {
            name: "DeleteDigitalGoods",
            I: cms_service_pb_1.CMSGoodsServiceDeleteDigitalGoodsRequest,
            O: cms_service_pb_1.CMSGoodsServiceDeleteDigitalGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * デジタルグッズのバリエーションの更新
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.UpdateVariantDigitalAll
         */
        updateVariantDigitalAll: {
            name: "UpdateVariantDigitalAll",
            I: cms_service_pb_1.CMSGoodsServiceUpdateVariantDigitalAllRequest,
            O: cms_service_pb_1.CMSGoodsServiceUpdateVariantDigitalAllResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * デジタルファイルのアップロードURLの取得
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.GetSignedUrlForDigitalGoodsFileUpload
         */
        getSignedUrlForDigitalGoodsFileUpload: {
            name: "GetSignedUrlForDigitalGoodsFileUpload",
            I: cms_service_pb_1.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest,
            O: cms_service_pb_1.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 自分で発送グッズの作成
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.CreateSelfShippingGoods
         */
        createSelfShippingGoods: {
            name: "CreateSelfShippingGoods",
            I: cms_service_pb_1.CMSGoodsServiceCreateSelfShippingGoodsRequest,
            O: cms_service_pb_1.CMSGoodsServiceCreateSelfShippingGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 自分で発送グッズの更新
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.UpdateSelfShippingGoods
         */
        updateSelfShippingGoods: {
            name: "UpdateSelfShippingGoods",
            I: cms_service_pb_1.CMSGoodsServiceUpdateSelfShippingGoodsRequest,
            O: cms_service_pb_1.CMSGoodsServiceUpdateSelfShippingGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 自分で発送グッズのバリエーションの更新
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.UpdateVariantSelfShippingAll
         */
        updateVariantSelfShippingAll: {
            name: "UpdateVariantSelfShippingAll",
            I: cms_service_pb_1.CMSGoodsServiceUpdateVariantSelfShippingAllRequest,
            O: cms_service_pb_1.CMSGoodsServiceUpdateVariantSelfShippingAllResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 自分で発送グッズの削除
         *
         * @generated from rpc spwn.goods.v1.CMSGoodsService.DeleteSelfShippingGoods
         */
        deleteSelfShippingGoods: {
            name: "DeleteSelfShippingGoods",
            I: cms_service_pb_1.CMSGoodsServiceDeleteSelfShippingGoodsRequest,
            O: cms_service_pb_1.CMSGoodsServiceDeleteSelfShippingGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=cms_service_connect.js.map